import React from 'react';
import PropTypes from 'prop-types';
import Loadable from '@loadable/component';
import { isBrowser } from '../../utils/is-browser';

const LoadableNarration = Loadable(() => import('./narration'));

const NarrationWrapper = ({ children }) => {
  if (isBrowser) {
    return (
      <LoadableNarration fallback={children}>{children}</LoadableNarration>
    );
  }

  return children;
};

NarrationWrapper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default NarrationWrapper;
